import { IconTooltip } from '../../../../IconTooltip';
import { StyledLoader } from '../../../../styled';
import { StyledLoaderWrap, StyledTitle, StyledWrapper, StyledWrapperTitle } from '../../styled';

type Props = {
  title: string;
  tooltip: string;
};

const LoadingView = ({ title, tooltip }: Props): JSX.Element => (
  <StyledWrapper data-testid="chartWrapper">
    <StyledWrapperTitle>
      <StyledTitle>{title}</StyledTitle>
      <div>
        <IconTooltip description={tooltip} />
      </div>
    </StyledWrapperTitle>
    <StyledLoaderWrap data-testid="wrapperForLoader">
      <StyledLoader data-testid="loader" />
    </StyledLoaderWrap>
  </StyledWrapper>
);

export default LoadingView;
